import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AytonomousTab from './AytonomousTab';


const AutonomousRegulations = () => {

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className='col-lg-4 pe-lg-5'>
                            <AytonomousTab />
                        </div>
                        <div className="col-lg-6 ps-lg-4">
                            <div className="how-to-apply">
                                <h2>
                                    Autonomous Regulations
                                </h2>
                            </div>
                            <div className='pt-2 pt-lg-3'>

                                <div className="detgails-right-content ">
                                    <div className="related-download bg-gray">
                                        <ul>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/autonomus/regulations/SWEC-D2-B.Tech-R25-ACADEMIC-REGULATIONS.pdf" target="_blank">
                                                    <i className="fa-solid fa-file-pdf"></i> R25 - B.Tech  Academic Regulations 
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/autonomus/regulations/SD-R22-MBA-Revised-AcademicRegulations.pdf" target="_blank">
                                                    <i className="fa-solid fa-file-pdf"></i> R22 - MBA Revised Academic Regulations
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/autonomus/regulations/SD-R22-B.Tech.-Revised-AcademicRegulations.pdf" target="_blank">
                                                    <i className="fa-solid fa-file-pdf"></i> R22 - B.Tech Revised Academic Regulations
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/autonomus/regulations/R22-M.Tech-AcdemicRegulations.pdf" target="_blank">
                                                    <i className="fa-solid fa-file-pdf"></i> R22 - M.Tech Academic Regulations
                                                </a>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}


export default AutonomousRegulations
